const MAX_HEIGHT = 50;

async function resizeImage(src: string, type: string): Promise<string> {
  const image = new Image();

  image.src = src;

  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement('canvas');

  if (image.height > MAX_HEIGHT) {
    image.width *= MAX_HEIGHT / image.height;
    image.height = MAX_HEIGHT;
  }

  const ctx = canvas.getContext('2d');

  canvas.width = image.width;
  canvas.height = image.height;

  ctx.drawImage(image, 0, 0, image.width, image.height);

  return canvas.toDataURL(type);
}

async function getFileImagePreview(file: File): Promise<string> {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  const event: any = await new Promise((resolve) => {
    reader.onload = resolve;
  });

  return resizeImage(event.target.result, file.type);
}

export default getFileImagePreview;
